import { ProductOption } from "./ProductOption.js";

export const requiredProductOptions: ProductOption[] = [ProductOption.Filling];
